import { AlertTriangle, ArrowRight } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

import { getBuildFeatureForPath } from '@/lib/feature-contract';
import { buildSetupReadiness, type SetupProjectFacts } from '@/lib/setup-readiness';

export function SetupReadinessBanner({
  project,
}: {
  project: SetupProjectFacts | null | undefined;
}) {
  const location = useLocation();
  const feature = getBuildFeatureForPath(location.pathname);
  const readiness = buildSetupReadiness(project);

  if (!feature?.requiresSetupReady || readiness.operationReady) return null;

  const missing = readiness.steps
    .filter((step) => step.blocksOperation && !step.done)
    .map((step) => step.label)
    .join(', ');

  return (
    <div className="mb-3 flex flex-col gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-950 sm:flex-row sm:items-center">
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span>
          <span className="font-medium">Setup baseline incomplete.</span>{' '}
          <span className="text-amber-900">{missing}</span>
        </span>
      </div>
      <Link
        to="/setup"
        className="inline-flex items-center gap-1 self-start rounded-md border border-amber-400 bg-background px-2 py-1 text-xs font-medium text-amber-950 hover:bg-amber-100 sm:self-auto"
      >
        Finish setup
        <ArrowRight className="h-3.5 w-3.5" />
      </Link>
    </div>
  );
}
